export default __webpack_public_path__ + "images/slide_12.jpeg?8749cb49ad027d53b25a7800467b4105";